<template>
  <div v-if="outline" class="space-y-3" data-test="report-outline">
    <section v-for="(sec, si) in outlineSections" :key="si" class="cm-panel shadow-sm">
      <div v-if="sec.title" class="cm-panel-head">
        <div class="cm-panel-title">{{ sec.title }}</div>
      </div>
      <ul v-if="sec.parts.length" class="px-4 py-3 text-sm text-gray-500 list-disc pl-8 space-y-1">
        <li v-for="(part, pi) in sec.parts" :key="pi">{{ part }}</li>
      </ul>
    </section>
  </div>
  <div v-else-if="sections.length" class="idt-detail space-y-3" data-test="report-layout">
    <section v-for="(sec, si) in visibleSections" :key="si" class="cm-panel shadow-sm">
      <div v-if="sec.title" class="cm-panel-head">
        <div class="cm-panel-title">{{ sec.title }}</div>
      </div>
      <div class="px-4 py-3">
        <ReportBlocks :blocks="sec.blocks" :output="output" :entity-id="entityId" />
      </div>
    </section>
  </div>
  <div v-else-if="blocks.length" class="idt-detail" data-test="report-layout">
    <ReportBlocks :blocks="blocks" :output="output" :entity-id="entityId" />
  </div>
</template>

<script>
import '@/assets/cm-tokens.css';
import ReportBlocks from '@/components/PersonalAnalyst/ReportBlocks.vue';

// A Hermes result drawn with its template's display.display_schema: titled sections (each shown only when its `requires`
// field has a value) or plain blocks. The Team Review board's patient summary and the template previews use it.
export default {
  name: 'ReportLayout',
  components: { ReportBlocks },
  props: {
    displaySchema: { type: Object, default: () => ({}) },
    output: { type: Object, default: () => ({}) },
    // Show only the layout: each section's title and what it shows, without any output.
    outline: { type: Boolean, default: false },
    entityId: { type: Number, default: 0 },
  },
  computed: {
    blocks() {
      return this.displaySchema?.blocks || [];
    },
    sections() {
      return this.displaySchema?.sections || [];
    },
    outlineSections() {
      const describe = (b) => {
        if (b.label || b.title) return b.label || b.title;
        if (Array.isArray(b.items) && b.items.length) return b.items.map((i) => i.label || i.field).filter(Boolean).join(', ');
        return String(b.field || b.type || '').replace(/^.*\./, '').replace(/_/g, ' ');
      };
      const groups = this.sections.length ? this.sections : [{ title: '', blocks: this.blocks }];
      return groups.map((sec) => ({ title: sec.title || '', parts: (sec.blocks || []).map(describe).filter(Boolean) }));
    },
    visibleSections() {
      return this.sections.filter((sec) => !sec.requires || this.hasValue(sec.requires));
    },
  },
  methods: {
    hasValue(path) {
      let node = this.output;
      for (const part of String(path).split('.')) {
        if (node === null || node === undefined) return false;
        node = node[part];
      }
      if (Array.isArray(node)) return node.length > 0;
      return node !== null && node !== undefined && node !== '';
    },
  },
};
</script>
